String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

window.getUrlParameter = function(sParam, defaultVal = false) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }

    return defaultVal;
}

window.fetchToken = () => {
    return new Promise((resolve, reject) => {
        fetch('/token')
        .then(async function(response) {
            if(response.status !== 200) {
                console.error(response);
                return;
            }

            console.log('response', response);
            let token = await response.json();
            console.log('token', token);

            resolve(token);
        })
        .catch(function(error) {
            console.error(error);
            reject(error);
        });
    });
}

window.moment = require('moment');
require('./bootstrap');
require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.it.min.js');

import TempusDominus from '@eonasdan/tempus-dominus';
import customDateFormat from '@eonasdan/tempus-dominus/dist/plugins/customDateFormat';
TempusDominus.extend(customDateFormat);
window.TempusDominus = TempusDominus.TempusDominus;
window.DateTime = TempusDominus.DateTime;

require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');

require('./datatables/buttons.server-side');
require('./datatables/datatables-custom');

require('chart.js/dist/chart.min');

require('./charts');

require('./visitaChat');
require('./calendar')

require('./support');

require('./deltaCom');
// require('./dailycoCallManager');
